import React, { useEffect, useState } from 'react'
import { FiArrowLeftCircle, FiPlus, FiPlusCircle, FiSave, FiSlash, FiTrash2 } from 'react-icons/fi'
import { Table } from '../../components/tables/Table';
import Swal from 'sweetalert2';
import { product_status, status_colors } from '../../app/Constants';
import { Loading } from '../../components/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { loadProductsAvaliable, newRequest } from '../../app/store/requests/thunk';
import { InputValidators } from '../../utils/InputValidators';

export const NewRequest = ({ navigateTo }) => {

  /** ToDo:
 * - De manera predeterminada todos los productoscon estado  AGOTADO se agregaran
*/
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadProductsAvaliable())
  }, [])

  const { isLoading, catProductsAvaliable, msg } = useSelector(state => state.requests);
  const { usuario, id_emp } = useSelector(state => state.usuario);
  const listProductsRequired = [...catProductsAvaliable];

  let user = id_emp;

  const [ProductsToADD, setProductsToADD] = useState([]);

  const addProduct = (row) => {
    const exists = ProductsToADD.some(p => p.SKU === row.SKU);
    if (exists) {
      Swal.fire({
        title: "Atencion",
        text: "Este producto ya esta en el listado de para compra",
        icon: "warning",
        confirmButtonText: "Aceptar",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary ", // <-- Personaliza aquí
        }
      });
      return;
    }

    const newItem = {
      ID: row.ID,
      SKU: row.SKU,
      BARCODE: row.BARCODE,
      NAME_PRODUCT: row.NAME_PRODUCT,
      DESCRIPTION_PRODUCT: row.DESCRIPTION_PRODUCT,
      MIN_STOCK: row.MIN_STOCK,
      MAX_STOCK: row.MAX_STOCK,
      ACTIVE: row.ACTIVE,
      IDCATEGORY: row.IDCATEGORY,
      NAMECATEGORY: row.NAMECATEGORY,
      IDSUPPLIER: row.IDSUPPLIER,
      NAMESUPPLIER: row.NAMESUPPLIER,
      IDBRAND: row.IDBRAND,
      NAMEBRAND: row.NAMEBRAND,
      STATUSDESC: row.STATUSDESC,
      CURRENTSTOCK: row.CURRENTSTOCK,
      QUANTITY_REQUIRED: row.QUANTITY_REQUIRED,
      QUANTITY_APPROVED: '',
    };
    setProductsToADD(prev => [...prev, newItem]);
  }

  const deleteProduct = (sku) => {
    Swal.fire({
      title: 'Atención',
      text: `Está por eliminar a un producto de la orden de compra, ¿Desea de continuar con esta acción?`,
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        setProductsToADD(prev => prev.filter(p => p.SKU !== sku));
      }
    })

  };


  const handleChangeApprovedQty = (sku, value) => {
    setProductsToADD(prev =>
      prev.map(p =>
        p.SKU === sku ? { ...p, QUANTITY_APPROVED: value } : p
      )
    );
  };

  let listProductsRequiredColumns = [
    {
      header: 'ACCIONES',
      dataIndex: 'status',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => (
        <div className="btn-group border-0" role="group">
          <button type="button" className="btn btn-outline-dark border-0" onClick={() => addProduct(row)} disabled={row.ACTIVE_ORDER != 'NINGUNA'}>
            <FiPlusCircle size={22} />
          </button>
        </div>
      )
    },
    {
      header: 'ORDEN ACTIVA',
      dataIndex: 'ACTIVE_ORDER',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) =>
        <span className="badge text-bg-dark">{value}</span>
    },
    {
      header: 'SKU',
      dataIndex: 'SKU',
      classHeader: 'text-start',
      classRow: 'text-start',

    },
    {
      header: 'CATEGORIA',
      dataIndex: 'NAMECATEGORY',
      classHeader: 'text-start',
      classRow: 'text-start',
    },

    {
      header: 'PRODUCTO',
      dataIndex: 'NAME_PRODUCT',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'DESCRIPCION',
      dataIndex: 'DESCRIPTION_PRODUCT',
      classHeader: 'text-start',
      classRow: 'text-start',
    },

    {
      header: 'PROVEEDOR',
      dataIndex: 'NAMESUPPLIER',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'CANT. REQUERIDA',
      dataIndex: 'QUANTITY_REQUIRED',
      classHeader: 'text-center',
      classRow: 'text-center',
    },

    {
      header: 'ESTADO',
      dataIndex: 'ACTIVE',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value) => {
        const code = Number(value);
        return (
          <span className={`badge ${status_colors[code]}`}>
            {product_status[code]}
          </span>
        );
      }
    }

  ];

  let listProductsAdd = [...ProductsToADD];




  let listProductsAddColumns = [
    {
      header: 'SKU',
      dataIndex: 'SKU',
      classHeader: 'text-start',
      classRow: 'text-start',

    },
    {
      header: 'CATEGORIA',
      dataIndex: 'NAMECATEGORY',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'MARCA',
      dataIndex: 'NAMEBRAND',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'PRODUCTO',
      dataIndex: 'NAME_PRODUCT',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'DESCRIPCION',
      dataIndex: 'DESCRIPTION_PRODUCT',
      classHeader: 'text-start',
      classRow: 'text-start',
    },

    {
      header: 'PROVEEDOR',
      dataIndex: 'NAMESUPPLIER',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'CANT. REQUERIDA',
      dataIndex: 'QUANTITY_REQUIRED',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'CANT. SOLICITDA',
      dataIndex: 'QUANTITY_APPROVED',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => (
        <input
          type="number"
          className="form-control text-center"
          min={0}
          onKeyDown={InputValidators.validateOnlyNumbers}
          style={{ width: "80px", margin: "0 auto" }}
          value={Number(value ?? '')}
          onChange={(e) => handleChangeApprovedQty(row.SKU, Number(e.target.value))}
        />
      )
    },

    {
      header: 'ESTADO',
      dataIndex: 'ACTIVE',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => {
        const code = Number(value);
        return (
          <span className={`badge ${status_colors[code]}`}>
            {product_status[code]}
          </span>
        );
      }
    },
    {
      header: 'ACCIONES',
      dataIndex: 'status',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => (
        <div className="btn-group border-0" role="group">
          <button type="button" className="btn btn-outline-danger border-0"
            onClick={() => deleteProduct(row.SKU)}
          >
            <FiTrash2 size={22} />
          </button>

        </div>
      )
    }
  ];

  const saveData = () => {
    let notes = "Registro de nueva orden";

    Swal.fire({
      title: 'Atención',
      text: `Está por registrar una Orden de compra de productos, ¿Desea de continuar con esta acción?`,
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false
    }).then((result) => {
      if (result.isConfirmed) {
        // Tomar el state enviar al thunk
        dispatch(newRequest(ProductsToADD, user, notes));
        setProductsToADD([])

      }
    })
  }

  const cancelRegister = () => {
    Swal.fire({
      title: 'Atención',
      text: `Está por cancelar el registro la Orden de compra de productos, ¿Desea de continuar con esta acción?`,
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        // clearFormulario
        navigateTo('list');
      }
    })
  }

  if (isLoading) {
    return (
      <Loading />
    )
  }

  return (
    <div className='row'>
      <div className='col-12 mb-3'>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
          <div className="d-flex mb-1">
            <button className="btn btn-outline-dark border-0" onClick={() => navigateTo('list')}>
              <FiArrowLeftCircle size={23} />
            </button>
            <h1 className="h4 fw-bold mt-2"> | Nueva Orden de Compra</h1>
          </div>
        </div>
      </div>

      <div className='col-12 '>
        <div className="card">
          <div className="card-header border-bottom">
            <h5 className="card-title mb-0 fw-bold text-dark">Listado de productos</h5>
          </div>
          <div className="card-body">
            <Table
              columns={listProductsRequiredColumns}
              data={listProductsRequired}
              function_={(row) => console.log('')}
              placeholderSearch="Buscar por: SKU, NOMBRE, CODIGO BARRA"
              showPagination={true}
              showControls={true}
              showTotals={false}
            />
          </div>
        </div>
      </div>

      <div className='col-12 '>
        <div className="card">
          <div className="card-header border-bottom">
            <h5 className="card-title mb-0 fw-bold text-dark">Agregados para la compra</h5>
          </div>
          <div className="card-body">
            <Table
              columns={listProductsAddColumns}
              data={listProductsAdd}
              function_={(row) => console.log('')}
              placeholderSearch="Buscar por: Folio, Capturante, Fecha, Estado"
              showPagination={false}
              showControls={false}
              showTotals={false}
            />
          </div>
          <div className='card-footer text-end border-top'>
            <button onClick={cancelRegister} type="button" className="btn btn-outline-danger me-2"  > <FiSlash size={22} /> Cancelar </button>
            <button onClick={saveData} type="button" className="btn btn-outline-primary"  > <FiSave size={22} /> Guardar </button>
          </div>
        </div>
      </div>







    </div>
  )
}
